import {defineStore} from 'pinia'
import {reactive, readonly, ref} from 'vue'
import axios from 'axios'
import {castAttributesForCamelCase} from 'src/biz_spa/modules/string_converter'
import {useFlash} from 'src/biz_spa/composables'
import type {allSitesConst} from 'src/biz_spa/modules/sitesConst'

type ConnectedServices = {
  serviceTypes: typeof allSitesConst[number]['siteType'][]
}

export const useCompaniesConnectedServices = defineStore('companiesConnectedServices', () => {
  const connectedServices: ConnectedServices = reactive({
    serviceTypes: []
  })
  const isLoading = ref<boolean>(false)
  const { updateFlash } = useFlash()

  const readCompaniesConnectedServices = async ({ companyUuid }: { companyUuid: string }) => {
    if (isLoading.value) return

    isLoading.value = true
    return axios
      .get(`/api/companies/${companyUuid}/connected_services`)
      .then(res => {
        const data = castAttributesForCamelCase(res.data.data) as ConnectedServices
        connectedServices.serviceTypes = data.serviceTypes
      })
      .catch(err => {
        updateFlash({ type: 'alert', message: err.response.data.errors[0].detail })
      })
      .finally(() => {
        isLoading.value = false
      })
  }

  return {
    isLoading: readonly(isLoading),
    connectedServices: readonly(connectedServices),
    readCompaniesConnectedServices,
  }
})
